export const common = {
  // Navigation
  'nav.home': 'Hjem',
  'nav.saddles': 'Sadler',
  'nav.riding_clothes': 'Ridebeklædning',
  'nav.stable_equipment': 'Staldinventar',
  'nav.grooming': 'Pleje',
  'nav.feed': 'Foder',
  'nav.about': 'Om os',
  'nav.contact': 'Kontakt',

  // Common buttons
  'btn.shop_saddles': 'Shop Sadler',
  'btn.browse_apparel': 'Gennemse Beklædning',
  'btn.view_all_products': 'Se Alle Produkter',
  'btn.view_product': 'Se Produkt',
  'btn.start': 'Start',
  'btn.end_call': 'Afslut Opkald',

  // Common text
  'text.featured': 'Fremhævet',
  'text.price_low_high': 'Pris: Lav til Høj',
  'text.price_high_low': 'Pris: Høj til Lav',
  'text.highest_rated': 'Højest Bedømt',
  'text.newest': 'Nyeste',
  'text.sort_by': 'Sorter efter:',
  'text.showing_results': 'Viser {count} resultater',
  'text.reviews': 'anmeldelser',
  'text.rating': 'Bedømmelse',

  // Footer
  'footer.brand_description': 'Din pålidelige kilde til premium hesteudstyr og rideudstyr. Vi samarbejder med topbrands for at bringe dig de bedste produkter til dig og din hest.',
  'footer.quick_links': 'Hurtige Links',
  'footer.support': 'Support',
  'footer.faq': 'FAQ',
  'footer.shipping_info': 'Forsendelsesinfo',
  'footer.returns': 'Returneringer',
  'footer.affiliate_disclosure': 'Affiliate Oplysning: EquiNord deltager i forskellige affiliate-programmer. Vi kan tjene en kommission fra kvalificerede køb foretaget gennem vores links uden ekstra omkostninger for dig.',
  'footer.rights_reserved': '© 2025 EquiNord. Alle rettigheder forbeholdes.',
  'footer.powered_by': 'Drevet af Readdy'
};

export default common;